<template>
    <div
        id="app"
        :class="appClasses"
    >
        <side-bar-navigation
            v-if="showMainNav"
            id="main-menu"
            class="full-height"
            :items="items"
        />
        <router-view class="page" />
    </div>
</template>

<script>
import SideBarNavigation from '@foundryspatial/side-bar-navigation';

import appLogo from '@/components/images/menuIcons/appLogo.vue';
import eca from '@/components/images/menuIcons/eca.vue';
import watershed from '@/components/images/menuIcons/watershed.vue';

export default {
    components: {
        SideBarNavigation,
    },

    data: () => ({
        items: [
            {
                icon: appLogo,
                link: { name: 'home' },
                exact: true, // use exact matching for "active" highlighting
                title: `${process.env.VUE_APP_TITLE} home`,
            },
            {
                icon: watershed,
                link: { name: 'watershed' },
                title: 'Watershed Reporting',
            },
        ],
    }),

    computed: {
        showMainNav() {
            return !!this.$route.meta.showMainNav;
        },

        appClasses() {
            return {
                'has-main-nav': this.showMainNav,
            };
        },
    },

    // @TEMP: enable or disable additional "beta" modules with environment variables
    created() {
        if (process.env.VUE_APP_ECA_MODULE_ENABLED === 'true') {
            this.items.push({
                icon: eca,
                link: { name: 'equivalent-clearcut-area' },
                title: 'Equivalent Clearcut Area',
            });
        }
    },
};
</script>

<style lang="scss">
// import global styles (Bulma, Buefy, etc.)
@import "~@/assets/scss/appStyles.scss";

</style>
